import {z} from 'zod'
import {AgendaEventFieldsSchema} from '@/features/agenda/formSchemas'
import {useFormContext, useWatch} from 'react-hook-form'
import {AgendaEventFormGenericFields} from '@/features/agenda/components/agenda-event-form/agenda-event-form-generic-fields/AgendaEventFormGenericFields'
import {AgendaEventFormSingleFields} from '@/features/agenda/components/agenda-event-form/agenda-event-form-single/AgendaEventFormSingleFields'
import {AgendaEventFormTeamFields} from '@/features/agenda/components/agenda-event-form/agenda-event-form-team-fields/AgendaEventFormTeamFields'
import {AgendaEventTypeSelector} from '@/features/agenda/components/agenda-event-form/agenda-event-type-selector/AgendaEventTypeSelector'

const AgendaEventFormFieldsSchema = AgendaEventFieldsSchema.pick({
    category: true,
    date: true,
    isGenericEvent: true
})
type AgendaEventFormFieldsSchema = z.infer<typeof AgendaEventFormFieldsSchema>

export const AgendaEventFormFields = ({mode, defaultDate}: {mode?: 'create' | 'edit'; defaultDate?: Date}) => {
    const {control} = useFormContext<AgendaEventFormFieldsSchema>()
    const category = useWatch({control, name: 'category'})
    const isGenericEvent = useWatch({control, name: 'isGenericEvent'})
    return (
        <>
            <AgendaEventTypeSelector mode={mode} />
            {isGenericEvent ? (
                <AgendaEventFormGenericFields />
            ) : category == 'team_meeting' ? (
                <AgendaEventFormTeamFields />
            ) : (
                <AgendaEventFormSingleFields mode={mode} defaultDate={defaultDate} />
            )}
        </>
    )
}
